import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/siraz.jpeg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import resume from '../assets/cv.pdf'

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [ ".NET Developer", "Full-Stack Web Developer", "React Developer" ];
  const period = 2000;
  const handleButtonClick = () => {
    // Open WhatsApp chat
    window.location.href = 'https://wa.me/01839721444'; // Replace with your actual phone number
  };
  const handleDownload = () => {
    window.open(resume, '_blank');
  };
  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">Welcome to my Profile</span>
                <h1>{`Hi! I'm Sirazul Islam`} <span className="txt-rotate" dataPeriod="1000" data-rotate='[ ".NET Developer", "Full-Stack Web Developer", "React Developer" ]'><span className="wrap">{text}</span></span></h1>
                  {/* <p>I'm a .NET Developer who is passionate about making error free software with 100% client satisfaction. I have a passion for learning and sharing my knowledge with others as publicly as possible. I love to solve real-world problems. I work with windows form, web forms, ASP.NET MVC, ASP.NET MVC Core, ASP.NET MVC Core API</p> */}
                  {/* <button onClick={handleDownload}>Let’s Connect <ArrowRightCircle size={25} /></button> */}
                  {/* <p>As a dedicated .NET Developer, I am committed to crafting error-free software that guarantees 100% client satisfaction. My passion for learning and sharing knowledge extends to public forums, where I actively contribute to the community. Specializing in Windows Forms, Web Forms, ASP.NET MVC, and ASP.NET MVC Core, I thrive on solving real-world problems with innovative solutions. From Windows Forms to the latest in MVC Core API, I am on a mission to build robust and client-centric software solutions.</p> */}
                  <p>Dedicated and proficient .NET Developer with a proven track record of
problem-solving excellence, having successfully tackled over 55 LeetCode
problems and 50 BeeCrowd problems. With a strong foundation in algorithms,
data structures, and software development methodologies, I possess the
expertise to devise efficient and scalable solutions to complex coding
challenges.</p>
                  <span className="banner-text">
                  <button className="vvd" onClick={handleDownload}><span>Resume</span></button>
                  </span>
                 
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
{/* <p>"I am an experienced software engineer with the ability to work collaboratively in a team and possess strong problem-solving skills for creating and designing software. I have hands-on experience with various .NET technologies, including ASP.NET, ASP.NET Core, Web Forms, ASP.NET MVC, Web API, Entity Framework Core, Windows Forms, and other related technologies. I am currently seeking a suitable position in a well-reputed organization to leverage my technical skills and further enhance my knowledge."</p> */}